$(function(){
  setTimeout(function(){
  $('.u_popup_toggle').removeAttr('href')
      },1000)
  $(document).on('click','.u_popup_toggle',function(e){
    console.log('click')
    e.preventDefault()
    $('.product-addons-text').trigger('click')
  })
  $(document).on('click','.block-quick-search,.bls-minicart-action',function(){
      $('.u_hamberger').removeClass('change');
    $('.u_mobile_menu').removeClass('active');
    $('html').removeClass('overflow');
  })
  if($(window).width()  < 768){
    let mini_cart = $('.header-mega-shop .bls__header_minicart').detach()
    $('.header-classic .col-header-right').append(mini_cart)
  }
  // $(document).on('click','.header_minicart',function(e){
  //   e.preventDefault();
  //   $('.header_minicart').addClass('bls__opend-popup-header')
  //   $('html').addClass('hside_opened')
  // })
    $(document).on('click','.bls-minicart-header .button-close,.u_cart_overlay',function(e){
     e.stopPropagation()
    $('.header_minicart').removeClass('bls__opend-popup-header')
    $('html').removeClass('hside_opened')
  })
    $('.u_hamberger,.u_mb_menu_overlay').click(function(){
    $('.u_hamberger').toggleClass('change');
    $('.u_mobile_menu').toggleClass('active');
    $('.u_nav_ul_mb').toggle();
       $('.u_mb_menu_overlay').toggle();
    $('html').toggleClass('overflow');     
  });
    // mb_navigation responsive
  $(document).on('click','.u_menu__link,.u_ficon_mb',function(){
    $(this).parent().find('i').toggleClass(' fa-angle-up  fa-angle-down');
    $(this).parent().parent().find('.u_sec_dropdown_mb').slideToggle();
  })
  // reverse
  $(document).on('click','.u_menu__dlink',function(){
    $(this).parents('.u_sec_dropdown_mb').find('.u_dropdown_list_mb_level:first-child .u_navbar_item_link_mb_level').toggleClass('u_active_smenu')
    $(this).toggleClass('u_active_smenu')
    $(this).parent().find('i').toggleClass(' fa-angle-up  fa-angle-down');
    $(this).parent().parent().find('.u_third_dropdown_mb').slideToggle();
  })
    $(document).on('click','.u_sicon_mb',function(){
    $(this).parents('.u_sec_dropdown_mb').find('.u_dropdown_list_mb_level:first-child .u_navbar_item_link_mb_level').toggleClass('u_active_smenu')
     $(this).parents('.u_dropdown_list_mb_inner').find('.u_navbar_item_link_mb_level').toggleClass('u_active_smenu')
    $(this).parent().find('i').toggleClass(' fa-angle-up  fa-angle-down');
    $(this).parent().parent().find('.u_third_dropdown_mb').slideToggle();
  })
  $(document).on('click','.u_pro_satc_btn',function(){
    console.log('click')
    $(this).addClass('u_btn_s_clr')
    $('.u_atc_default_text').hide();
    $('.u_atc_size_text').text('SELECTEER EERST EEN MAAT')
   let ths = $(this)
    setTimeout(function(){
          ths.removeClass('u_btn_s_clr')
    $('.u_atc_default_text').show();
    $('.u_atc_size_text').empty()
    },3000)
  })
      $(document).on('click','.u_read_more,.u_less_more',function(){
        console.log('click tab')
        var $tabPanel = $(this).closest('.tab-panel');
        $(this).closest('.u_read_more_wrapper').toggleClass('u_active_text'); 
        $tabPanel.toggleClass('u_active_text');
        $tabPanel.find('.u_tab_wrapper').toggleClass('u_inline_text');   

    })

  // Show More Button Visibility Check
  // Only show the button if content is actually taller than max-height + margin
  function checkShowMoreButtonVisibility() {
    $('.u_tab_wrapper').each(function() {
      const $wrapper = $(this);
      const maxHeightStyle = $wrapper.css('max-height');
      
      // Check if max-height is set (not 'none')
      if (maxHeightStyle && maxHeightStyle !== 'none' && maxHeightStyle !== '0px') {
        // Get max-height value from data attribute or parse from style
        let maxHeight = parseInt($wrapper.data('max-height'));
        if (!maxHeight || isNaN(maxHeight)) {
          maxHeight = parseInt(maxHeightStyle);
        }
        
        // Get margin from data attribute, default to 30px
        const margin = parseInt($wrapper.data('margin')) || 30;
        
        // Get actual scroll height (full content height)
        const scrollHeight = this.scrollHeight;
        
        // Calculate threshold
        const threshold = maxHeight + margin;
        
        // Find the corresponding read more wrapper (in same tab-panel)
        const $tabPanel = $wrapper.closest('.tab-panel');
        const $readMoreWrapper = $tabPanel.find('.u_read_more_wrapper').first();
        
        if ($readMoreWrapper.length) {
          // Hide button if content is not significantly taller than max-height + margin
          if (scrollHeight <= threshold) {
            $readMoreWrapper.hide();
            $tabPanel.addClass('u_hide_read_more');
          } else {
            $readMoreWrapper.show();
            $tabPanel.removeClass('u_hide_read_more');
          }
        }
      }
    });
  }

  // Run on page load
  $(document).ready(function() {
    // Wait a bit for content to render
    setTimeout(checkShowMoreButtonVisibility, 100);
    setTimeout(checkShowMoreButtonVisibility, 500);
  });

  // Run on window resize (with debounce)
  let resizeTimerShowMore;
  $(window).on('resize', function() {
    clearTimeout(resizeTimerShowMore);
    resizeTimerShowMore = setTimeout(function() {
      checkShowMoreButtonVisibility();
    }, 250);
  });

  // Also check when tabs are opened/closed
  $(document).on('click', '.tab-item .item.title, .data.item', function() {
    setTimeout(checkShowMoreButtonVisibility, 300);
  });

  // Upsell add to cart functionality
  $(document).on('click', '.upsell_add_to_cart_btn', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    const button = $(this);
    const variantId = button.data('variant-id');
    const productId = button.data('product-id');
    
    if (!variantId) {
      console.error('Variant ID not found');
      return;
    }
    
    // Disable button and add loading state
    button.prop('disabled', true);
    button.addClass('btn-loading');
    
    // Get cart element
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    
    // Create form data
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
    }
    
    // Fetch config
    const config = typeof fetchConfig === 'function' ? fetchConfig('json') : {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    };
    config.headers = config.headers || {};
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;
    
    // Add to cart
    const cartAddUrl = (typeof routes !== 'undefined' && routes.cart_add_url) ? routes.cart_add_url : '/cart/add.js';
    
    fetch(`${cartAddUrl}.js`, config)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        // Update cart count
        fetch('/cart.json')
          .then(res => res.json())
          .then(cart => {
            document.querySelectorAll(".cart-count").forEach(el => {
              if (el.classList.contains('cart-count-drawer')) {
                el.innerHTML = `(${cart.item_count})`;
              } else {
                el.innerHTML = cart.item_count;
              }
            });
            
            // Update free shipping progress bar if exists
            const cart_free_ship = document.querySelector("free-ship-progress-bar");
            if (cart_free_ship && typeof cart_free_ship.init === 'function') {
              cart_free_ship.init(cart.items_subtotal_price);
            }
          })
          .catch((error) => {
            console.error('Error updating cart count:', error);
          });
        
        // Update cart sections if cart element exists
        if (cart && typeof cart.getSectionsToRender === 'function') {
          const parsedState = JSON.parse(state);
          cart.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id);
            if (elementToReplace && parsedState.sections && parsedState.sections[section.id]) {
              const html = new DOMParser().parseFromString(parsedState.sections[section.id], 'text/html');
              const cartContent = html.querySelector('#form-mini-cart');
              if (cartContent) {
                elementToReplace.innerHTML = cartContent.innerHTML;
              }
              
              // Update countdown if exists
              const countdown = cart.querySelector('.cart-countdown-time');
              const html_countdown = html.querySelector('.cart-countdown-time');
              if (countdown && html_countdown) {
                countdown.innerHTML = html_countdown.innerHTML;
                if (typeof cart.countdownTimer === 'function') {
                  cart.countdownTimer();
                }
              }
            }
          }));
          
          // Trigger cart action if method exists
          if (typeof cart.cartAction === 'function') {
            cart.cartAction();
          }
        }
        
        // Open cart drawer/notification
        if (cart && typeof cart.open === 'function') {
          cart.open();
        }
      })
      .catch((e) => {
        console.error('Error adding to cart:', e);
        // You could show an error message here
      })
      .finally(() => {
        // Re-enable button and remove loading state
        button.prop('disabled', false);
        button.removeClass('btn-loading');
        
        // Reinitialize lazy load images if function exists
        if (typeof BlsLazyloadImg !== 'undefined' && typeof BlsLazyloadImg.init === 'function') {
          BlsLazyloadImg.init();
        }
      });
  });

  // Upsell Load More functionality - ULTRA SIMPLE VERSION WITH DEBUG
  (function() {
    'use strict';
    
    const DEBUG = false; // Set to true for console logging
    function log() {
      if (DEBUG && console && console.log) {
        console.log.apply(console, arguments);
      }
    }
    
    // Simple state per group
    const groupState = {};
    
    function getItemsPerLoad() {
      const items = window.innerWidth > 575 ? 2 : 1;
      log('getItemsPerLoad:', items, 'width:', window.innerWidth);
      return items;
    }

    function getInitialVisibleCount() {
      const items = window.innerWidth > 575 ? 2 : 1;
      log('getInitialVisibleCount:', items, 'width:', window.innerWidth);
      return items;
    }

      // Initialize a single group
      function initGroup(groupId) {
        log('=== INIT GROUP:', groupId, '===');
        
        // CRITICAL FIX: Skip if already initialized OR loading OR user has clicked
        if (groupState[groupId]) {
          if (groupState[groupId].loading) {
            log('Already loading, skip init');
            return;
          }
          if (groupState[groupId].initialized && groupState[groupId].userHasClicked) {
            log('User has clicked, skip re-init');
            return;
          }
          if (groupState[groupId].initialized) {
            log('Already initialized, skip init');
            return;
          }
        }
        
        // CRITICAL FIX: Get ALL wrappers with this group ID
        const wrappers = document.querySelectorAll(`[data-upsell-group-id="${groupId}"][data-enable-load-more="true"]`);
        if (wrappers.length === 0) {
          log('No wrappers found for groupId:', groupId);
          return;
        }
        
        log('Found', wrappers.length, 'wrappers for groupId:', groupId);
        
        const loadMoreBtn = document.querySelector(`.upsell-load-more-btn[data-group-id="${groupId}"]`);
        if (!loadMoreBtn) {
          log('No button found');
          return;
        }
        
        const totalProducts = parseInt(loadMoreBtn.getAttribute('data-total-products')) || 0;
        const initialVisible = getInitialVisibleCount();
        
        log('Total:', totalProducts, 'InitialVisible:', initialVisible);
        
        // Process EACH wrapper
        wrappers.forEach(function(wrapper) {
          const products = Array.from(wrapper.querySelectorAll('.upsell-product-item'));
          log('Processing wrapper with', products.length, 'products');
          
          if (products.length === 0) return;
          
          // Reset - remove all classes and inline styles
          products.forEach(function(product, i) {
            product.classList.remove('upsell-product-hidden');
            product.style.display = ''; // Clear any inline style
            log('Product', i, '- reset');
          });
          
          // Then hide based on viewport
          products.forEach(function(product, index) {
            if (index >= initialVisible) {
              product.classList.add('upsell-product-hidden');
              log('Product', index, '- hidden');
            } else {
              log('Product', index, '- visible');
            }
          });
        });
        
        // Initialize state
        groupState[groupId] = {
          initialized: true,
          loading: false,
          visibleCount: initialVisible,
          totalProducts: totalProducts,
          userHasClicked: false
        };
        
        log('State after init:', groupState[groupId]);
        
        // Update button
        updateButtonVisibility(groupId, loadMoreBtn, wrappers[0], totalProducts);
      }

    function updateButtonVisibility(groupId, btn, wrapper, totalProducts) {
      if (!btn || !wrapper) return;
      
      const loadMoreWrapper = btn.closest('.upsell-load-more-wrapper');
      if (!loadMoreWrapper) return;
      
      const visibleCount = wrapper.querySelectorAll('.upsell-product-item:not(.upsell-product-hidden)').length;
      
      log('updateButtonVisibility - visible:', visibleCount, 'total:', totalProducts);
      
      if (visibleCount >= totalProducts) {
        loadMoreWrapper.style.display = 'none';
        log('Hide button');
      } else {
        loadMoreWrapper.style.display = 'block';
        log('Show button');
      }
      
      if (groupState[groupId]) {
        groupState[groupId].visibleCount = visibleCount;
      }
    }

    function initAllGroups() {
      log('=== INIT ALL GROUPS ===');
      const wrappers = document.querySelectorAll('[data-enable-load-more="true"]');
      log('Found wrappers:', wrappers.length);
      
      wrappers.forEach(function(wrapper) {
        const groupId = wrapper.getAttribute('data-upsell-group-id');
        if (groupId) {
          initGroup(groupId);
        }
      });
    }

      // Click handler
      document.addEventListener('click', function(e) {
        const btn = e.target.closest('.upsell-load-more-btn');
        if (!btn) return;
        
        e.preventDefault();
        e.stopPropagation();
        
        const groupId = btn.getAttribute('data-group-id');
        if (!groupId) {
          log('No groupId on button');
          return;
        }
        
        log('=== BUTTON CLICKED:', groupId, '===');
        
        // Init if needed
        if (!groupState[groupId] || !groupState[groupId].initialized) {
          log('Not initialized, init now');
          initGroup(groupId);
        }
        
        // Check loading
        if (groupState[groupId] && groupState[groupId].loading) {
          log('Already loading');
          return false;
        }
        
        // Mark loading AND that user has clicked
        if (!groupState[groupId]) {
          groupState[groupId] = { initialized: true, loading: false, visibleCount: 0, totalProducts: 0, userHasClicked: false };
        }
        groupState[groupId].loading = true;
        groupState[groupId].userHasClicked = true;
        log('Set loading = true, userHasClicked = true');
        
        // CRITICAL FIX: Use querySelectorAll to update ALL matching wrappers
        const wrappers = document.querySelectorAll(`[data-upsell-group-id="${groupId}"][data-enable-load-more="true"]`);
        log('Found', wrappers.length, 'wrappers to update');
        
        if (wrappers.length === 0) {
          log('No wrappers found');
          groupState[groupId].loading = false;
          return false;
        }
        
        // Collect products to show from ALL wrappers
        const allProductsToShow = [];
        
        wrappers.forEach(function(wrapper) {
          const products = Array.from(wrapper.querySelectorAll('.upsell-product-item'));
          const itemsPerLoad = getItemsPerLoad();
          
          log('Wrapper products:', products.length, 'ItemsPerLoad:', itemsPerLoad);
          
          // Find hidden products in this wrapper
          const productsToShow = [];
          for (let i = 0; i < products.length && productsToShow.length < itemsPerLoad; i++) {
            const isHidden = products[i].classList.contains('upsell-product-hidden');
            if (products[i] && isHidden) {
              productsToShow.push(products[i]);
            }
          }
          
          log('ProductsToShow in this wrapper:', productsToShow.length);
          
          // Add to global list
          allProductsToShow.push(...productsToShow);
        });
        
        if (allProductsToShow.length === 0) {
          log('No products to show at all');
          groupState[groupId].loading = false;
          return false;
        }
        
        // Show loading on button
        btn.disabled = true;
        const textSpan = btn.querySelector('.upsell-load-more-text');
        const loaderSpan = btn.querySelector('.upsell-load-more-loader');
        if (textSpan) textSpan.style.display = 'none';
        if (loaderSpan) {
          loaderSpan.style.display = 'inline-block';
          loaderSpan.style.visibility = 'visible';
        }
        
        // Show products AFTER loader animation (700ms for better UX)
        setTimeout(function() {
          log('=== SHOW PRODUCTS AFTER LOADER ===');
          
          // NOW remove hidden class from products
          allProductsToShow.forEach(function(product) {
            product.classList.remove('upsell-product-hidden');
            log('Removed hidden class from product');
          });
          
          // Update button visibility for first wrapper
          const firstWrapper = wrappers[0];
          const newVisibleCount = firstWrapper.querySelectorAll('.upsell-product-item:not(.upsell-product-hidden)').length;
          const totalProducts = parseInt(btn.getAttribute('data-total-products')) || newVisibleCount;
          
          log('New visible count:', newVisibleCount);
          
          // Reset button
          btn.disabled = false;
          if (textSpan) textSpan.style.display = 'inline';
          if (loaderSpan) loaderSpan.style.display = 'none';
          
          updateButtonVisibility(groupId, btn, firstWrapper, totalProducts);
          
          groupState[groupId].loading = false;
          groupState[groupId].visibleCount = newVisibleCount;
          
          log('State after click:', groupState[groupId]);
          
          // Lazy load
          if (typeof BlsLazyloadImg !== 'undefined' && typeof BlsLazyloadImg.init === 'function') {
            BlsLazyloadImg.init();
          }
        }, 700);
        
        return false;
      }, true);

    // Initialize
    function init() {
      log('=== INIT CALLED ===');
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
          log('DOM loaded, init groups');
          setTimeout(initAllGroups, 100);
        });
      } else {
        log('DOM already loaded, init groups');
        setTimeout(initAllGroups, 100);
      }
      
      setTimeout(initAllGroups, 300);
    }
    
    init();
    
      // Resize handler
      let resizeTimer;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
          log('=== RESIZE, reinit ===');
          
          // CRITICAL: Only reset groups where user has NOT clicked
          Object.keys(groupState).forEach(function(groupId) {
            if (groupState[groupId] && !groupState[groupId].userHasClicked) {
              groupState[groupId].initialized = false;
              log('Reset group', groupId, 'for re-init');
            } else {
              log('Skip reset for group', groupId, '- user has clicked');
            }
          });
          
          initAllGroups();
        }, 250);
      });
  })();
})

// Product Info Block - Tab Link Functionality
// Use jQuery event delegation like all other click handlers in this file
$(document).on('click', '.product-info-block__extra-text--link[data-tab-class]', function(e) {
  e.preventDefault();
  e.stopPropagation();
  
  console.log('=== TAB LINK CLICKED ===');
  console.log('Event type:', e.type);
  console.log('Window width:', $(window).width());
  
  const $link = $(this);
  const tabClass = $link.attr('data-tab-class');
  console.log('Tab class from link:', tabClass);
  
  if (!tabClass) {
    console.log('No tab class found!');
    return;
  }
  
  // Split multiple classes if provided (e.g., "betaling_tab" from "discription_tab betaling_tab")
  const classes = tabClass.trim().split(/\s+/);
  
  // Find the best matching tab
  let tabElement = null;
  let bestMatch = null;
  let bestMatchScore = 0;
  
  // CRITICAL: On mobile (<= 991px), only search tabs in .bls__product-details-infor
  // On desktop, search tabs in .bls__product-images
  const isMobileTabMode = $(window).width() <= 991;
  const searchScope = isMobileTabMode ? '.bls__product-details-infor .tab-item' : '.tab-item';
  console.log('Searching in scope:', searchScope);
  
  // Search through all tabs to find the best match
  $(searchScope).each(function() {
    const tab = this;
    const tabClasses = tab.className.split(/\s+/).filter(function(c) {
      return c && c !== 'tab-item' && c !== 'tab-accordition' && c !== 'active' && c !== 'app-block';
    });
    
    // Calculate match score
    let matchScore = 0;
    let hasAllClasses = true;
    
    classes.forEach(function(targetClass) {
      if (tabClasses.indexOf(targetClass) !== -1) {
        matchScore += 2; // Exact match gets higher score
      } else {
        hasAllClasses = false;
      }
    });
    
    // Bonus points if tab has the target class and fewer other classes (more specific)
    if (matchScore > 0) {
      matchScore += (10 - tabClasses.length) * 0.1; // Prefer tabs with fewer classes (more specific)
    }
    
    // Perfect match: tab has all the classes we're looking for
    if (hasAllClasses && matchScore > bestMatchScore) {
      bestMatch = tab;
      bestMatchScore = matchScore;
    }
    // Good match: tab has at least one of the classes
    else if (matchScore > 0 && matchScore > bestMatchScore) {
      bestMatch = tab;
      bestMatchScore = matchScore;
    }
  });
  
  // Use the best match
  if (bestMatch) {
    tabElement = bestMatch;
  }
  
  // Fallback: if still not found, try simple selector in the correct scope
  if (!tabElement && classes.length > 0) {
    tabElement = $(searchScope + '.' + classes[0])[0];
  }
  
  if (!tabElement) {
    console.warn('Tab not found for class:', tabClass);
    console.log('All tabs:', $('.tab-item').length);
    $('.tab-item').each(function(i) {
      console.log('Tab', i, 'classes:', this.className);
    });
    return;
  }
  
  console.log('Found tab element:', tabElement);
  console.log('Tab element classes:', tabElement.className);
  
  const $tabElement = $(tabElement);
  const tabId = tabElement.id;
  console.log('Tab ID:', tabId);
  
  if (!tabId) {
    console.warn('Tab element has no ID');
    return;
  }
  
  const $tabToggle = $('[data-block-id="' + tabId + '"]').first(); // Use .first() to get only one
  console.log('Tab toggle found:', $tabToggle.length);
  
  if (!$tabToggle.length) {
    console.warn('Tab toggle not found for ID:', tabId);
    return;
  }
  
  const isOpen = $tabElement.hasClass('active');
  const $panel = $tabElement.find('.tab-panel');
  
  console.log('Panel found:', $panel.length);
  console.log('Panel display:', $panel.css('display'));
  console.log('Tab element visible:', $tabElement.is(':visible'));
  console.log('Tab element offset before opening:', $tabElement.offset());
  
  // Detect mobile for different scroll offset
  const isMobile = $(window).width() < 1025;
  const scrollOffset = isMobile ? 150 : 100;
  const delay = isOpen ? 50 : 350;
  
  console.log('Is mobile:', isMobile);
  console.log('Scroll offset:', scrollOffset);
  console.log('Is tab open:', isOpen);
  console.log('Delay:', delay);
  
  // If it's an accordion tab
  if ($tabElement.hasClass('tab-accordition')) {
    // Close other tabs if needed (check for multi-open)
    const $multiOpen = $tabElement.closest('[data-multi-open="true"]').length || 
                      $('.bls__product-tabs [data-multi-open="true"]').length;
    
    if (!$multiOpen) {
      const $container = $tabElement.closest('.tab-content').length ? 
                        $tabElement.closest('.tab-content') : $(document);
      $container.find('.tab-item.active').each(function() {
        if (this === tabElement) return;
        $(this).removeClass('active');
        const $p = $(this).find('.tab-panel');
        if (typeof slideAnimeHidden === 'function') {
          slideAnimeHidden({ target: $p[0] });
        } else {
          $p.hide();
        }
      });
    }
    
    // On mobile (<= 991px), use the theme's native tab toggle handler
    if (isMobileTabMode) {
      console.log('Mobile mode detected - TRIGGER CLICK on tab title');
      
      // Find the tab title element
      const $title = $tabElement.find('.item.title').first();
      console.log('Title element found:', $title.length);
      console.log('Tab is currently open:', isOpen);
      
      // If tab is closed, trigger a click to open it using the native handler
      if (!isOpen && $title.length) {
        console.log('Triggering click on title to open tab...');
        $title.trigger('click');
      }
      
      // Wait for animation, then scroll
      setTimeout(function() {
        // Force recalculate position after tab opens
        const elementPosition = $tabElement.offset().top;
        const offsetPosition = Math.max(0, elementPosition - scrollOffset);
        console.log('Mobile - Element position:', elementPosition);
        console.log('Mobile - Offset position:', offsetPosition);
        console.log('Mobile - Tab visible:', $tabElement.is(':visible'));
        console.log('Mobile - Tab height:', $tabElement.height());
        console.log('Mobile - Panel display:', $panel.css('display'));
        
        if (elementPosition > 0) {
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        } else {
          console.error('Mobile - Element position is still 0! Tab did not open properly.');
        }
      }, 500); // Wait for native animation to complete
      
    } else {
      // DESKTOP: Use original logic
      console.log('Desktop mode - using original logic');
      
      // Close other tabs if needed (check for multi-open)
      const $multiOpen = $tabElement.closest('[data-multi-open="true"]').length || 
                        $('.bls__product-tabs [data-multi-open="true"]').length;
      
      if (!$multiOpen) {
        const $container = $tabElement.closest('.tab-content').length ? 
                          $tabElement.closest('.tab-content') : $(document);
        $container.find('.tab-item.active').each(function() {
          if (this === tabElement) return;
          $(this).removeClass('active');
          const $p = $(this).find('.tab-panel');
          if (typeof slideAnimeHidden === 'function') {
            slideAnimeHidden({ target: $p[0] });
          } else {
            $p.hide();
          }
        });
      }
      
      // Always open the target tab
      if (!isOpen) {
        if (typeof slideAnime === 'function') {
          slideAnime({ target: $panel[0], animeType: 'slideDown' });
        } else {
          $panel.show();
        }
        $tabElement.addClass('active');
      }
      
      // Scroll to tab
      setTimeout(function() {
        const elementPosition = $tabElement.offset().top;
        const offsetPosition = Math.max(0, elementPosition - scrollOffset);
        console.log('Desktop - Element position:', elementPosition);
        console.log('Desktop - Offset position:', offsetPosition);
        
        if (elementPosition > 0) {
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, isOpen ? 50 : 350);
    }
    
  } else {
    // Handle regular tabs (nav tabs)
    if (!isOpen) {
      // Close other tabs
      $('.data.item').removeClass('active');
      $('.tab-item').removeClass('active').find('.tab-panel').hide();
      
      // Open target tab
      $tabElement.addClass('active');
      $panel.show();
      $tabToggle.closest('.data.item').addClass('active');
    }
    
    // Scroll to tab
    setTimeout(function() {
      const elementPosition = $tabElement.offset().top;
      const offsetPosition = Math.max(0, elementPosition - scrollOffset);
      console.log('Nav tab - Element position:', elementPosition);
      console.log('Nav tab - Offset position:', offsetPosition);
      console.log('Nav tab - Current scroll:', $(window).scrollTop());
      
      // Use native smooth scroll for better mobile support
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }, delay);
  }
  
  console.log('=== TAB LINK END ===');
});